module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/social/apple-4536fd0738f36c3463bccee34510b7ec.svg";